import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PersonalPage from "../pages/personal/page";
import CoursesPage from "../pages/courses/page";
import EssentialCourse from "../pages/courses/essential/page";
import AdvancedCourse from "../pages/courses/advanced/page";
import MasterCourse from "../pages/courses/master/page";
import SchedulePage from "../pages/schedule/page";
import SeminarPage from "../pages/courses/seminar/page";
import SeminarConfirmPage from "../pages/courses/seminar/confirm/page";
import SeminarCompletePage from "../pages/courses/seminar/complete/page";
import CorporatePage from "../pages/corporate/page";
import CorporateCompletePage from "../pages/corporate/complete/page";
import CorporateBrochurePage from "../pages/corporate/brochure/page";
import CorporateBrochureConfirmPage from "../pages/corporate/brochure/confirm/page";
import CorporateBrochureCompletePage from "../pages/corporate/brochure/complete/page";
import CorporateHotelPage from "../pages/corporate/hotel/page";
import CorporateHotelCompletePage from "../pages/corporate/hotel/complete/page";
import CorporateResidencePage from "../pages/corporate/residence/page";
import CorporateResidenceCompletePage from "../pages/corporate/residence/complete/page";
import CorporateFinancePage from "../pages/corporate/finance/page";
import CorporateFinanceCompletePage from "../pages/corporate/finance/complete/page";
import CorporateLuxurySalesPage from "../pages/corporate/luxury-sales/page";
import CorporateLuxurySalesCompletePage from "../pages/corporate/luxury-sales/complete/page";
import CorporateRetailPage from "../pages/corporate/retail/page";
import CorporateRetailCompletePage from "../pages/corporate/retail/complete/page";
import CorporateClinicPage from "../pages/corporate/clinic/page";
import CorporateClinicCompletePage from "../pages/corporate/clinic/complete/page";
import CorporateAutomotivePage from "../pages/corporate/automotive/page";
import CorporateAutomotiveCompletePage from "../pages/corporate/automotive/complete/page";
import CorporateChauffeurPage from "../pages/corporate/chauffeur/page";
import CorporateChauffeurCompletePage from "../pages/corporate/chauffeur/complete/page";
import FAQPage from "../pages/faq/page";
import BlogListPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blog/detail/page";
import AboutPage from "../pages/about/page";
import PhilosophyPage from "../pages/philosophy/page";
import AssociationPage from "../pages/association/page";
import FacilitiesPage from "../pages/facilities/page";
import AccessPage from "../pages/access/page";
import CurriculumPage from "../pages/curriculum/page";
import TrainingPage from "../pages/training/page";
import MaterialsPage from "../pages/materials/page";
import SkillsPage from "../pages/skills/page";
import PricingPage from "../pages/pricing/page";
import PricingDetailsPage from "../pages/pricing/details/page";
import BenefitsPage from "../pages/benefits/page";
import CertificatePage from "../pages/certificate/page";
import AdmissionPage from "../pages/admission/page";
import ApplicationPage from "../pages/application/page";
import ApplyPage from "../pages/apply/page";
import ApplyConfirmPage from "../pages/apply/confirm/page";
import ApplyCompletePage from "../pages/apply/complete/page";
import ConsultationPage from "../pages/consultation/page";
import ConsultationConfirmPage from "../pages/consultation/confirm/page";
import ConsultationCompletePage from "../pages/consultation/complete/page";
import ContactPage from "../pages/contact/page";
import ContactConfirmPage from "../pages/contact/confirm/page";
import ContactCompletePage from "../pages/contact/complete/page";
import BrochurePage from "../pages/brochure/page";
import BrochureConfirmPage from "../pages/brochure/confirm/page";
import BrochureCompletePage from "../pages/brochure/complete/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import RecruitmentListPage from "../pages/recruitment/page";
import RecruitmentDetailPage from "../pages/recruitment/detail/page";
import SitemapPage from "../pages/sitemap/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import CommercialLawPage from "../pages/commercial-law/page";
import RelatedPage from "../pages/related/page";
import RelatedButlerAssociationPage from "../pages/related/butler-association/page";
import RelatedButlerBellPage from "../pages/related/butler-bell/page";
import RelatedTheButlerPage from "../pages/related/the-butler/page";
import RelatedFamilyRomancePage from "../pages/related/family-romance/page";
import RelatedIshiiYuichiPage from "../pages/related/ishii-yuichi/page";
import PresidentPage from "../pages/president/page";
import JapanButlerAcademyPage from "../pages/japan-butler-academy/page";
import ButlerSchoolPage from "../pages/butler-school/page";
import ButlerTrainingSchoolPage from "../pages/butler-training-school/page";
import ButlerJobPage from "../pages/butler-job/page";
import HowToBecomeButlerPage from "../pages/how-to-become-butler/page";
import OverseasSchoolsPage from "../pages/overseas-schools/page";
import OverseasSchoolDetailPage from "../pages/overseas-schools/detail/page";
import ButlerSchoolHistoryPage from "../pages/butler-school-history/page";

function createChildRoutes(): RouteObject[] {
  return [
    {
      index: true,
      element: <Home />,
    },
    {
      path: "personal",
      element: <PersonalPage />,
    },
    {
      path: "courses",
      element: <CoursesPage />,
    },
    {
      path: "courses/essential",
      element: <EssentialCourse />,
    },
    {
      path: "courses/advanced",
      element: <AdvancedCourse />,
    },
    {
      path: "courses/master",
      element: <MasterCourse />,
    },
    {
      path: "schedule",
      element: <SchedulePage />,
    },
    {
      path: "seminar",
      element: <SeminarPage />,
    },
    {
      path: "seminar/confirm",
      element: <SeminarConfirmPage />,
    },
    {
      path: "seminar/complete",
      element: <SeminarCompletePage />,
    },
    {
      path: "corporate",
      element: <CorporatePage />,
    },
    {
      path: "corporate/complete",
      element: <CorporateCompletePage />,
    },
    {
      path: "corporate/brochure",
      element: <CorporateBrochurePage />,
    },
    {
      path: "corporate/brochure/confirm",
      element: <CorporateBrochureConfirmPage />,
    },
    {
      path: "corporate/brochure/complete",
      element: <CorporateBrochureCompletePage />,
    },
    {
      path: "corporate/hotel",
      element: <CorporateHotelPage />,
    },
    {
      path: "corporate/hotel/complete",
      element: <CorporateHotelCompletePage />,
    },
    {
      path: "corporate/residence",
      element: <CorporateResidencePage />,
    },
    {
      path: "corporate/residence/complete",
      element: <CorporateResidenceCompletePage />,
    },
    {
      path: "corporate/finance",
      element: <CorporateFinancePage />,
    },
    {
      path: "corporate/finance/complete",
      element: <CorporateFinanceCompletePage />,
    },
    {
      path: "corporate/luxury-sales",
      element: <CorporateLuxurySalesPage />,
    },
    {
      path: "corporate/luxury-sales/complete",
      element: <CorporateLuxurySalesCompletePage />,
    },
    {
      path: "corporate/retail",
      element: <CorporateRetailPage />,
    },
    {
      path: "corporate/retail/complete",
      element: <CorporateRetailCompletePage />,
    },
    {
      path: "corporate/clinic",
      element: <CorporateClinicPage />,
    },
    {
      path: "corporate/clinic/complete",
      element: <CorporateClinicCompletePage />,
    },
    {
      path: "corporate/automotive",
      element: <CorporateAutomotivePage />,
    },
    {
      path: "corporate/automotive/complete",
      element: <CorporateAutomotiveCompletePage />,
    },
    {
      path: "corporate/chauffeur",
      element: <CorporateChauffeurPage />,
    },
    {
      path: "corporate/chauffeur/complete",
      element: <CorporateChauffeurCompletePage />,
    },
    {
      path: "faq",
      element: <FAQPage />,
    },
    {
      path: "blog",
      element: <BlogListPage />,
    },
    {
      path: "blog/:slug",
      element: <BlogDetailPage />,
    },
    {
      path: "about",
      element: <AboutPage />,
    },
    {
      path: "philosophy",
      element: <PhilosophyPage />,
    },
    {
      path: "association",
      element: <AssociationPage />,
    },
    {
      path: "facilities",
      element: <FacilitiesPage />,
    },
    {
      path: "access",
      element: <AccessPage />,
    },
    {
      path: "curriculum",
      element: <CurriculumPage />,
    },
    {
      path: "training",
      element: <TrainingPage />,
    },
    {
      path: "materials",
      element: <MaterialsPage />,
    },
    {
      path: "skills",
      element: <SkillsPage />,
    },
    {
      path: "pricing",
      element: <PricingPage />,
    },
    {
      path: "pricing/details",
      element: <PricingDetailsPage />,
    },
    {
      path: "benefits",
      element: <BenefitsPage />,
    },
    {
      path: "certificate",
      element: <CertificatePage />,
    },
    {
      path: "admission",
      element: <AdmissionPage />,
    },
    {
      path: "application",
      element: <ApplicationPage />,
    },
    {
      path: "apply",
      element: <ApplyPage />,
    },
    {
      path: "apply/confirm",
      element: <ApplyConfirmPage />,
    },
    {
      path: "apply/complete",
      element: <ApplyCompletePage />,
    },
    {
      path: "consultation",
      element: <ConsultationPage />,
    },
    {
      path: "consultation/confirm",
      element: <ConsultationConfirmPage />,
    },
    {
      path: "consultation/complete",
      element: <ConsultationCompletePage />,
    },
    {
      path: "contact",
      element: <ContactPage />,
    },
    {
      path: "contact/confirm",
      element: <ContactConfirmPage />,
    },
    {
      path: "contact/complete",
      element: <ContactCompletePage />,
    },
    {
      path: "brochure",
      element: <BrochurePage />,
    },
    {
      path: "brochure/confirm",
      element: <BrochureConfirmPage />,
    },
    {
      path: "brochure/complete",
      element: <BrochureCompletePage />,
    },
    {
      path: "news",
      element: <NewsPage />,
    },
    {
      path: "news/:slug",
      element: <NewsDetailPage />,
    },
    {
      path: "recruitment",
      element: <RecruitmentListPage />,
    },
    {
      path: "recruitment/:slug",
      element: <RecruitmentDetailPage />,
    },
    {
      path: "sitemap",
      element: <SitemapPage />,
    },
    {
      path: "privacy",
      element: <PrivacyPage />,
    },
    {
      path: "terms",
      element: <TermsPage />,
    },
    {
      path: "commercial-law",
      element: <CommercialLawPage />,
    },
    {
      path: "related",
      element: <RelatedPage />,
    },
    {
      path: "related/butler-association",
      element: <RelatedButlerAssociationPage />,
    },
    {
      path: "related/butler-bell",
      element: <RelatedButlerBellPage />,
    },
    {
      path: "related/the-butler",
      element: <RelatedTheButlerPage />,
    },
    {
      path: "related/family-romance",
      element: <RelatedFamilyRomancePage />,
    },
    {
      path: "related/ishii-yuichi",
      element: <RelatedIshiiYuichiPage />,
    },
    {
      path: "president",
      element: <PresidentPage />,
    },
    {
      path: "japan-butler-academy",
      element: <JapanButlerAcademyPage />,
    },
    {
      path: "butler-school",
      element: <ButlerSchoolPage />,
    },
    {
      path: "butler-training-school",
      element: <ButlerTrainingSchoolPage />,
    },
    {
      path: "butler-job",
      element: <ButlerJobPage />,
    },
    { path: "how-to-become-butler", element: <HowToBecomeButlerPage /> },
    {
      path: "overseas-schools",
      element: <OverseasSchoolsPage />,
    },
    {
      path: "overseas-schools/:slug",
      element: <OverseasSchoolDetailPage />,
    },
    {
      path: "butler-school-history",
      element: <ButlerSchoolHistoryPage />,
    },
  ];
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Outlet />,
    children: createChildRoutes(),
  },
  {
    path: "/en",
    element: <Outlet />,
    children: createChildRoutes(),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
